import { Button } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { useFormContext } from 'react-hook-form';

import type { FormFields } from '@/entities/purchase-form';

import { useIsFormValid } from '../../model';

const PDP_PURCHASE_FORM_ID = 'pdp-purchase-form';

const submitPurchaseForm = () => {
    const form = document.getElementById(PDP_PURCHASE_FORM_ID) as HTMLFormElement;
    if (form) {
        form.requestSubmit();
    }
};

type AutoshipButtonProps = Readonly<{
    onAuthRequired: (callback: () => void) => Promise<void>;
}>;

/**
 * Deprecated
 * Will be deleted after "crawl" release
 */
export const AutoshipButton = ({ onAuthRequired }: AutoshipButtonProps) => {
    const {
        formState: { isSubmitting },
    } = useFormContext<FormFields>();

    const { isValid } = useIsFormValid();

    const handleClick = async () => {
        await onAuthRequired(submitPurchaseForm);
    };

    const ctaText = isSubmitting ? 'Added to Autoship' : 'Add to Autoship';

    return (
        <Button
            size="lg"
            fullWidth
            type="button"
            text={ctaText}
            variant="primary"
            disabled={!isValid || isSubmitting}
            data-testid="autoship-button"
            className={cn({ 'add-to-cart-button--success': isSubmitting })}
            onClick={handleClick}
        />
    );
};
